import { Column, Row } from '@simplywallst/ui-core';
import {
  SidebarTitle,
  SidebarText,
  YouTubeTitle,
  ShareClubImage,
  SidebarContainer,
} from '../styled';
import YouTube from '@assets/images/podcasts/youtube-logo.svg';
import { useCloudflareImage, getStaticUrl } from '@/hooks/useCloudflareImage';
const Sidebar = () => {
  const swsSharedClubSrc = useCloudflareImage({
    src: getStaticUrl('sws-shareclub.png'),
  });
  return (
    <SidebarContainer justifyContent="center">
      <Column alignContent="center">
        <ShareClubImage
          src={swsSharedClubSrc}
          alt="Simply wall st share club"
        />
        <SidebarTitle>Simply Wall St Shareclub</SidebarTitle>
        <SidebarText>
          Shareclub is where our team learn to invest together and we’re happy
          to share our learnings with the world.
        </SidebarText>
        <YouTubeTitle>Check out our channel on</YouTubeTitle>
        <Row justifyContent="center">
          <a
            href="https://youtube.com/playlist?list=PLVdrK24l-IHejlx8Ep4PBmSFF6mCfPQzo"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <YouTube />
          </a>
        </Row>
      </Column>
    </SidebarContainer>
  );
};

export default Sidebar;
